import { render, staticRenderFns } from "./DialogChurch.vue?vue&type=template&id=1c9daa5e&scoped=true"
import script from "./DialogChurch.vue?vue&type=script&lang=js"
export * from "./DialogChurch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9daa5e",
  null
  
)

export default component.exports